import type { PlanningDateChoice } from "@learn-flow/contracts";

import { addLocalDays } from "../calendar/calendar-date.js";

export function reflectionCalendarStartDate(
  choice: PlanningDateChoice,
  today: string,
  suggestedDate: string,
): string {
  if (choice === "one_week" || choice === "two_weeks") {
    return addLocalDays(suggestedDate, -2);
  }
  return today;
}

export function previousReflectionCalendarStartDate(startDate: string, today: string): string {
  const previous = addLocalDays(startDate, -7);
  return previous < today ? today : previous;
}
